import { SearchRecommendation, SearchRecommendationType } from "../../types";
import { sendClickEvent } from "../analytics/google-analytics";
import { Icon } from "./Icon";

interface SearchRecommendationProps {
  query: string;
  recommendations: SearchRecommendation[];
}

export const SearchRecommendations = ({
  query,
  recommendations,
}: SearchRecommendationProps) => {
  function boldifySearchQuery(name: string) {
    const regex = new RegExp(`(${query})`, "gi");
    return name.replace(regex, "<strong>$1</strong>");
  }

  function getUrl(link: string) {
    try {
      const { protocol, hostname, port } = window.location;
      const baseUrl = `${protocol}//${hostname}${port ? `:${port}` : ""}`;

      const url = new URL(baseUrl + link);
      return url.toString();
    } catch {
      return link;
    }
  }

  function sendGAEvent(recommendation: SearchRecommendation) {
    sendClickEvent(`search_recommendation_click`, recommendation.name);
  }

  return recommendations.map((recommendation) => (
    <li>
      <a
        href={getUrl(recommendation.link)}
        onClick={() => sendGAEvent(recommendation)}
      >
        {recommendation.type === SearchRecommendationType.Webshop && (
          <Icon name="category" aria-hidden="true" />
        )}
        {recommendation.type === SearchRecommendationType.Warehouse && (
          <Icon name="sell" aria-hidden="true" />
        )}
        {recommendation.type === SearchRecommendationType.QuerySuggestion && (
          <Icon name="search" aria-hidden="true" />
        )}
        <span
          dangerouslySetInnerHTML={{
            __html: boldifySearchQuery(recommendation.name),
          }}
        ></span>
      </a>
    </li>
  ));
};
